"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQRCodeUploader = void 0;
const react_1 = require("react");
const ui_common_uploader_1 = require("@desygner/ui-common-uploader");
function useQRCodeUploader({ type = 'logo', companionUrl, bucketName, objectKey, }) {
    const uploader = (0, react_1.useMemo)(() => {
        const options = {
            companionUrl,
            bucket: bucketName,
            objectKey,
        };
        return new ui_common_uploader_1.Uploader(type, options);
    }, []);
    const uploadQRCode = (0, react_1.useCallback)(() => {
        return new Promise((resolve) => {
            uploader.openDashboard((result) => {
                if (!(result === null || result === void 0 ? void 0 : result.successful) || result.successful.length === 0) {
                    resolve([]);
                }
                const response = result.successful
                    .map((item) => item.uploadURL)
                    .filter(Boolean);
                resolve(response);
            });
        });
    }, [uploader]);
    return {
        uploadQRCode,
    };
}
exports.useQRCodeUploader = useQRCodeUploader;
//# sourceMappingURL=useQRCodeUploader.js.map